import { ParsedFragmentEntity } from '@entities/ParsedFragment/Types';

export const GetFragmentByItemTypeId = (
    itemTypeId: number,
    parsedFragments: ParsedFragmentEntity[]
): ParsedFragmentEntity | null => {
    return (
        parsedFragments.find(fragment =>
            fragment.itemTypes.some(item => item.id === itemTypeId)
        ) ?? null
    );
};
